module.exports = __webpack_public_path__ + "img/omega-square-1.f51c57ae.svg";